
import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}

function MenuFooter({ color }: Props): ReactElement {

    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 17.5H13M5 12.5H19M11 7.5H19" stroke={color ? color : "#1F1F1F"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    );
}

export default MenuFooter;